<template>
  <div>
    <div v-if="tipo === 'TEXT' || tipo === 'TEXTAREA'">
      <el-alert
        v-if="respostaTexto.resposta"
        :closable="false"
        :description="respostaTexto.resposta"
      />
      <el-alert
        v-else
        type="info"
        :closable="false"
        show-icon
        title="Não informado"
      />
    </div>

    <div v-else>
      <el-row :gutter="10">
        <el-col
          v-for="alternativa in alternativas"
          :key="alternativa.id"
          :span="24"
        >
          <div class="alternativa-item">
            <span
              class="custom-radio"
              :class="{ checked: alternativa.selecionada }"
            ></span>
            <span class="descricao">{{ alternativa.descricao }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "RespostaView",
  props: {
    tipo: String,
    alternativas: {
      type: Array,
      default: () => [],
    },
    respostaTexto: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.alternativa-item {
  display: flex;
  align-items: center;
  padding: 4px;
  padding-left: 1rem;
}

.custom-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  margin-right: 10px;
}

.custom-radio.checked {
  border-color: #67c23a;
  background-color: #67c23a;
}

.custom-radio.checked::after {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
}

.descricao {
  font-size: 14px;
  color: #303133;
}
</style>
